import { render, staticRenderFns } from "./ReportDetailBody.vue?vue&type=template&id=0530e8d4&scoped=true"
import script from "./ReportDetailBody.vue?vue&type=script&lang=js"
export * from "./ReportDetailBody.vue?vue&type=script&lang=js"
import style0 from "./ReportDetailBody.vue?vue&type=style&index=0&id=0530e8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530e8d4",
  null
  
)

export default component.exports